// extracted by mini-css-extract-plugin
export default {"container":"pH-z","error":"qH-z","disabled":"rH-z","submit":"sH-z","option":"tH-z","success":"uH-z","failure":"vH-z"};